// For-Sale marketplace constants — keep in sync with /api/marketplace/categories
export const MARKET_CATEGORIES = [
  "Real Estate", "Vehicles", "Electronics", "Furniture",
  "Fashion", "Collectibles", "Other",
];

export const ITEM_CONDITIONS = [
  { id: "new",       label: "New" },
  { id: "like_new",  label: "Like new" },
  { id: "good",      label: "Good" },
  { id: "fair",      label: "Fair" },
];

const SYMBOL = { USD: "$", EUR: "€", GBP: "£", AUD: "A$", CAD: "C$", JPY: "¥" };
export const fmtPrice = (item) => {
  const sym = SYMBOL[item?.currency] || `${item?.currency || "USD"} `;
  return `${sym}${Number(item?.price || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
};
export const conditionLabel = (id) => (ITEM_CONDITIONS.find(c => c.id === id) || {}).label || id;
